import {EnrollmentFormModel} from 'models/EnrollmentForm';
import React from 'react';

import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router';
import { EnrollmentFormServiceInstance } from 'services/enrollmentFormService';
import { AllErrors, NotFoundError } from 'types/Errors';
import { Key } from 'types/Key';

import { CeoEnrollmentFormGeneratedProps } from './CeoEnrollmentForm.props';
import CeoEnrollmentFormView from './CeoEnrollmentForm.view';

const CeoEnrollmentForm = (): JSX.Element => {
  // MARK:- Hooks
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };

  // MARK:- Queries
  // TODO:- Fetch EnrollmentFormById
  const getEnrollmentByIdQuery = useQuery(
    ['EnrollmentId', id],
    () => EnrollmentFormServiceInstance.getById(id),
    {
      onSuccess: () => {
        // Do Nothing
      },
      onError: (error: AllErrors) => {
        if (error instanceof NotFoundError) {
          navigate('/not-found');
        }

        console.error(error);
      },
    }
  );

  // MARK:- Mutation
  const submitCeoEnrollmentForm = useMutation(
    (data: EnrollmentFormModel) => EnrollmentFormServiceInstance.update(data, id),
    {
      onSuccess: () => {
        navigate('/success');
      },
      onError: (error: AllErrors) => {
        if (error instanceof NotFoundError) {
          navigate('/not-found');
          return;
        }
      },
    }
  );

  // MARK:- Functions
  function onSubmitForm(data: EnrollmentFormModel) {
    submitCeoEnrollmentForm.mutate({
      ...data,
      surveyId:
        (getEnrollmentByIdQuery.data?.body.surveyId as Key)?.name ||
        (getEnrollmentByIdQuery.data?.body.surveyId as Key)?.id ||
        '',
    });
  }

  const generatedProps: CeoEnrollmentFormGeneratedProps = {
    isLoading: getEnrollmentByIdQuery.isLoading,
    enrollmentForm: getEnrollmentByIdQuery.data?.body,
    isSubmitting: submitCeoEnrollmentForm.isLoading,
    onSubmitForm,
  };
  return <CeoEnrollmentFormView {...generatedProps} />;
};

export default CeoEnrollmentForm;
